import { useParams } from 'react-router-dom';

import { useGetPrePurchaseByIdQuery } from '@/features/slice/purchases';

export const usePrePurchaseDetails = () => {
    const params = useParams();
    const prePurchaseId = params['id'] || '';

    const { data, isFetching, isLoading, isError, error } =
        useGetPrePurchaseByIdQuery(prePurchaseId);
    return {
        data,
        isFetching,
        isLoading,
        isError,
        error,
    };
};
